<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="dataTable"
      :items-per-page="20"
      :footer-props="footerProps"
      class="elevation-1 table-job-detail"
      @click:row="handleClick"
    >
      <template v-if="isEdit" v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click.stop="editItem(item)">
          mdi-pencil
        </v-icon>
      </template>

      <template v-slot:item.warning_status="{ item }">
        <div class="flex-center">
          <v-chip
            v-if="getStatusChip(item).status"
            class="ma-2 v-chip-width"
            :color="getStatusChip(item).color"
            width="50px"
          >
            <span class="text-white">
              {{ getStatusChip(item).status }}
            </span>
          </v-chip>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    data: Object,
  },

  computed: {
    ...mapState({
      isEdit: (state) => state?.me?.data?.permission?.stock_edit,
      searchJobDetail: (state) => state.job?.searchJobDetail,
      statusJobDetail: (state) => state?.job?.statusJobDetail,
    }),
    dataTable() {
      const filter = this.data?.filter(
        (i) =>
          i?.store_id
            ?.toUpperCase()
            ?.includes(`${this.searchJobDetail?.toUpperCase()}`) ||
          i?.store_name
            ?.toUpperCase()
            ?.includes(`${this.searchJobDetail?.toUpperCase()}`),
      )

      // ยังไม่ได้นับ
      if (this.statusJobDetail === 5) {
        return (
          filter.filter(
            (i) =>
              +i?.warning_status?.includes(`stock have no check`),
          ) ?? []
        )
      }
      // สต็อคไม่ตรง
      else if (this.statusJobDetail === 6) {
        return (
          filter?.filter(
            (i) => +i?.warning_status?.includes(`not match`),
          ) ?? []
        )
      }
      // ไม่มีสต็อคสินค้า
      else if (this.statusJobDetail === 7) {
        return (
          filter.filter(
            (i) =>
              +i?.warning_status?.includes(`no stock list to do`),
          ) ?? []
        )
      }
      // สมบูรณ์
      else if (this.statusJobDetail === 8) {
        return (
          filter.filter(
            (i) => +i?.warning_status?.includes(`completed`),
          ) ?? []
        )
      } else if (this.statusJobDetail === 9) {
        return (
          filter.filter(
            (i) =>
              +i?.warning_status?.includes(
                'stock not match with defect',
              ),
          ) ?? []
        )
      } else if (this.statusJobDetail === 10) {
        return (
          filter.filter(
            (i) =>
              +i?.warning_status?.includes('completed with defect'),
          ) ?? []
        )
      } else {
        return filter ?? []
      }
    },
  },

  data() {
    return {
      footerProps: { 'items-per-page-options': [10, 20, 50, 100] },
      headers: [
        {
          text: 'รหัสสาขา',
          align: 'start',
          sortable: false,
          value: 'store_id',
        },
        {
          text: 'สาขา',
          align: 'start',
          sortable: false,
          value: 'store_name',
        },
        {
          text: 'แบรนด์',
          value: 'product_brand',
          align: 'start',
        },
        { text: 'หมวดหมู่', value: 'category', align: 'start' },
        { text: 'หมวดหมู่ย่อย', value: 'sub_cat', align: 'start' },
        { text: 'โปรดักโค้ด', value: 'sku', align: 'start' },
        {
          text: 'ผลการตรวจนับ',
          value: 'warning_status',
          align: 'center',
        },
        {
          text: 'เครื่องมือ',
          value: 'actions',
          sortable: false,
          align: 'center',
        },
      ],
      footer_props: {
        'items-per-page-options': [],
        'items-per-page-text': null,
        'disable-items-per-page': true,
      },
    }
  },

  methods: {
    handleClick(value) {
      this.$router.push({
        name: 'StoreDetail',
        params: {
          id: this.$route.params.id,
          storeId: value.store_id,
        },
      })
    },

    editItem(value) {
      this.$router.push({
        name: 'EditStore',
        params: {
          id: this.$route.params.id,
          storeId: value.store_id,
        },
      })
    },

    getStatusChip(val) {
      if (val?.warning_status == 'stock not match') {
        return {
          status: 'สต็อคไม่ตรง',
          color: 'orange',
        }
      } else if (
        val?.warning_status?.includes(`no stock list to do`)
      ) {
        return {
          status: 'ไม่มีสต็อคสินค้า',
          color: '#727272',
        }
      } else if (val?.warning_status == 'completed') {
        return {
          status: 'สมบูรณ์',
          color: 'green',
        }
      } else if (val?.warning_status == `completed with defect`) {
        return {
          status: 'นับครบแต่มีข้อบกพร่อง',
          color: '#2db7f5',
        }
      } else if (
        val?.warning_status == 'stock not match with defect'
      ) {
        return {
          status: 'นับไม่ครบและมีข้อบกพร่อง',
          color: '#fd8f8f',
        }
      } else if (
        val?.warning_status?.includes(`stock have no check`)
      ) {
        return {
          status: 'ยังไม่ได้นับ',
          color: 'red',
        }
      } else {
        return {
          status: val?.warning_status,
          color: '',
        }
      }
    },
  },
}
</script>

<style>
.table-job-detail .v-chip-width {
  width: fit-content !important;
  max-width: fit-content !important;
  padding: 0 10px;
  text-align: center;
  display: flex;
  justify-content: center;
}
.text-white {
  color: white;
}
</style>

<style scoped>
/deep/ table > tbody > tr > td:nth-child(8),
/deep/ table > thead > tr > th:nth-child(8) {
  position: sticky !important;
  position: -webkit-sticky !important;
  right: 0;
  z-index: 8;
  background: white;
}
/deep/ table > thead > tr > th:nth-child(8) {
  z-index: 8;
}
</style>
